import { render, staticRenderFns } from "./PruneBackupRepoDialog.vue?vue&type=template&id=3d665a7d&"
import script from "./PruneBackupRepoDialog.vue?vue&type=script&lang=ts&"
export * from "./PruneBackupRepoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports